module.exports = __webpack_public_path__ + "img/Ifkovits Markus.jpg";